import RedirectBackButton from "components/RedirectBackButton";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import useTrashablePromises from "hooks/useTrashablePromises";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import {
  CertificateThemeRequest,
  SaveResponse,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import CertificateThemeForm from "./CertificateThemeForm";

const CertificateThemeCreateForm = () => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const {
    certificateService,
    certificateThemesUrl,
    certificateThemeDetailsUrl,
  } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useTitle(t({ id: "certificateThemeFormCreateButton" }));

  const onCancel = () => {
    navigate(certificateThemesUrl());
  };

  const onSubmit = async (values: CertificateThemeRequest) => {
    try {
      const response: SaveResponse = await registerPromise(
        certificateService.saveCertificateTheme(values)
      );
      queryClient.invalidateQueries("certificateThemes");
      navigate(certificateThemeDetailsUrl(response.id));
      return response;
    } catch (err: any) {
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <RedirectBackButton
        redirectRoute={certificateThemesUrl()}
        labelKey="backToListButtonLabel"
      />
      <h2>
        <T id="certificateThemeFormCreateTitle" />
      </h2>
      <CertificateThemeForm
        onSubmit={onSubmit}
        submitLabel={t({ id: "certificateThemeFormCreateButton" })}
        onCancel={onCancel}
      />
    </>
  );
};

export default CertificateThemeCreateForm;
